/**
 * @author michalstolarski
 * @since 2024-1-26
 */

import * as React from "react";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

import { Props } from "./LoaderBolt.types";
import * as Styled from "./LoaderBolt.styles";

export const LoaderBolt = ({
  size = 65,
  padding = 0,
  ...props
}: Props): React.ReactElement => (
  <TestWrapper testId={props.testId}>
    <Styled.Container
      className={props.className}
      $size={size}
      $padding={padding}
    >
      <Styled.SVG
        viewBox="0 0 52 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Styled.Group>
          <path
            d="M2.01489 26.8376C1.90489 23.6878 2.41638 20.5471 3.52013 17.595C4.62389 14.6429 6.29831 11.937 8.44778 9.63201C10.5972 7.32699 13.1797 5.4679 16.0476 4.1609C18.9156 2.8539 22.0129 2.12459 25.1627 2.01459C28.3125 1.9046 31.4531 2.41608 34.4052 3.51984C37.3574 4.6236 40.0632 6.29801 42.3682 8.44749C44.6733 10.597 46.5323 13.1794 47.8393 16.0473C49.1463 18.9153 49.8757 22.0126 49.9856 25.1624C50.0956 28.3122 49.5842 31.4528 48.4804 34.405C47.3766 37.3571 45.7022 40.0629 43.5528 42.3679C41.4033 44.673 38.8208 46.532 35.9529 47.839C33.085 49.146 29.9877 49.8754 26.8379 49.9854C23.688 50.0953 20.5474 49.5839 17.5953 48.4801C14.6432 47.3763 11.9373 45.7019 9.6323 43.5525C7.32728 41.403 5.46819 38.8206 4.16119 35.9526C2.8542 33.0847 2.12488 29.9874 2.01489 26.8376L2.01489 26.8376Z"
            stroke="#DDE7FF"
            strokeWidth="4"
          />
          <path
            d="M2.01489 26.8376C1.88271 23.0524 2.64823 19.2897 4.24888 15.8571C5.84952 12.4245 8.23984 9.4195 11.2244 7.08772"
            stroke="#4902F9"
            strokeWidth="4"
            strokeLinecap="round"
          />
        </Styled.Group>

        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.1191 13L26.762 23.2377L32.6045 23.1615L20.4854 38L24.8349 27.7623L19 27.8385L31.1191 13Z"
          fill="#FFD900"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.9043 27.808L19 27.8385L31.1191 13L29.0701 17.8218L20.9043 27.808Z"
          fill="#417360"
        />
      </Styled.SVG>
    </Styled.Container>
  </TestWrapper>
);
